function Error({message = 'Failed to load component'}: {message?: string}) {
    return <div>{message}</div>;
}

Error.displayName = 'Error';

export {Error};
